<template>
  <div>
    <a-table
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="categories"
      :loading="loading"
      :pagination="false"
    >
      <template slot="active" slot-scope="active">
        <a-tag :color="active === 1 ? 'green' : 'red'">
          {{ active === 1 ? 'Active' : 'Inactive' }}
        </a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <div class="text-nowrap">
          <a
            href="javascript:;"
            v-if="rolesetting.editable"
            class="btn btn-sm btn-light btn-with-addon mr-2"
            @click="showEditModal(record)"
          >
            <span class="btn-addon"><i class="btn-addon-icon fe fe-edit" /></span>
            Edit
          </a>

          <a
            href="javascript:;"
            v-if="rolesetting.deletable"
            class="btn btn-sm btn-danger btn-with-addon"
            @click="onDelete(record)"
          >
            <span class="btn-addon"><i class="btn-addon-icon fe fe-trash" /></span>
            Delete
          </a>
        </div>
      </template>
    </a-table>

    <edit-category ref="editCategory" @edited="handleEdited" />
  </div>
</template>

<script>
import EditCategory from '@/components/disciplineManagement/disciplineCategories/Form/Edit'

const columns = [
  { title: 'Name', dataIndex: 'name', width: 100 },
  { title: 'Description', dataIndex: 'description', width: 150 },
  { title: 'Active', dataIndex: 'active', scopedSlots: { customRender: 'active' }, width: 100 },
  { title: 'Actions', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 150, className: 'text-right' },
]

export default {
  name: 'CategoriesTable',
  components: { EditCategory },
  props: {
    rolesetting: Object,
    loading: Boolean,
    categories: Array,
  },
  data() {
    return { columns }
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openCategoryEditModal', record.id)
    },
    handleEdited() {
      this.$emit('updateTable')
    },
    onDelete(record) {
      this.$confirm({
        title: 'Delete this category?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete(`/api/student-discipline-category/${record.id}`)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification.success({
                message: 'Deleted Successfully',
                description: `${record.name} has been deleted.`,
              })
            })
            .catch((error) => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
      })
    },
  },
}
</script>
